import { Platform, View } from "react-native";
import React from "react";
import ExperienceCard from "./ExperienceCard";
import dimensions from "../../../../../globalStyles/dimensions";

const AllExperienceList = ({ data }: { data: any }) => {
  const renderExperienceCard = (item: any) => (
    <ExperienceCard key={item._id} {...item} />
  );
  return (
    <>
      <View
        style={{
          flexDirection: "row",
          flexWrap: "wrap",
          justifyContent: "flex-start",
          alignItems: 'center',
          paddingHorizontal: (Platform.OS === 'ios' || Platform.OS === 'android') ? dimensions.paddingHorizontal : 0,
          gap: (Platform.OS === 'ios' || Platform.OS === 'android') ? dimensions.windowWidth * 0.022 : 10,
          marginLeft: (Platform.OS === 'ios' || Platform.OS === 'android') ? 0 : 20
        }}
      >
        {data?.map(renderExperienceCard)}
      </View>
    </>
  );
};

export default AllExperienceList;